<button
  *ngIf="filters?.length"
  class="collapse-btn d-flex btn btn-outline-primary"
  [ngClass]="{ 'disabled-control': !isTextTruncated && isCollapsed }"
  type="button"
  data-test-id="selected-filters-button"
  (click)="toggleFiltersVisibility()"
>
  <div
    #textBlock
    [ngClass]="isCollapsed ? 'text-truncate w-100' : 'py-1'"
    class="w-100 text-break"
    data-test-id="selected-filters-block"
    [style.hyphens]="'auto'"
  >
    <ng-container *ngFor="let filterBlock of filters; let isLastBlock = last; index as i">
      <span
        *ngFor="let filter of filterBlock; let isLast = last; index as j"
        [attr.data-test-id]="'selected-filter-' + i + '-' + j"
      >
        {{ filter | translate }}{{ isLast ? '' : '; ' }}
      </span>
      <strong>{{ isLastBlock ? '' : ' | ' }}</strong>
    </ng-container>
  </div>
</button>
